module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/员工关怀-text.69629b74.png";